import { Suspense, FC } from 'react';
import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { JsonLD } from './json-ld';
import { OG } from './og';
import { $PageLevelTraffic } from 'shared/atoms';
import { useHashtagDesc } from '../shared/use-hashtag-desc';
import { $CurrentAvailableHashtagInfoOrNull } from '~/routes/topic.$hashtag_id/shared/atoms';

const HashtagHeadInner: FC = () => {
  const { t } = useTranslation();
  const hashtag = useAtomValue($CurrentAvailableHashtagInfoOrNull);
  const { canonicalUrl } = useAtomValue($PageLevelTraffic);
  const description = useHashtagDesc();

  if (!hashtag) {
    return null;
  }

  const { name } = hashtag;
  const keywords = `#${name}`;
  const title = `${t('related_helmet_title').replace('%s', `#${name}`)} | Lemon8`;

  const fb_appid = 426786581540674;

  return (
    <>
      <title>{title}</title>
      <meta key="keywords" name="keywords" content={keywords} />
      <meta key="description" name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />
      <meta property="fb:app_id" content={String(fb_appid)} />
      <JsonLD />
      <OG />
    </>
  );
};

export const HashtagHead: FC = () => {
  return (
    <Suspense fallback={<></>}>
      <HashtagHeadInner />
    </Suspense>
  );
};
